import ClassNames from "classnames";
import * as React from "react";

import Styles from "./InputLabel.module.css";

export interface Props {
  label: string;
  className?: string;
  hideLabel?: boolean;
  htmlFor?: string;
  required?: boolean;
  nativeRequired?: boolean;
}

const InputLabel: React.FC<Props> = props => {
  const {
    className,
    hideLabel,
    htmlFor,
    label,
    required,
    nativeRequired
  } = props;

  return (
    <label
      className={ClassNames({
        [Styles.label]: true,
        "sr-only": hideLabel,
        [className]: className
      })}
      htmlFor={htmlFor}
    >
      {label}
      {(required || nativeRequired) && <span className={Styles.required} />}
    </label>
  );
};

export default InputLabel;
